import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { SyslogItem } from "./request/request";

export function makeSyslogFields(): FilterField<SyslogItem>[] {
  const fields: FilterField<SyslogItem>[] = [
    {
      label: "IP",
      key: "ip",
      accessor: (r) => r.ip,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.description || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Port",
      key: "port",
      accessor: (r) => r.port.toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "ID",
      key: "id",
      accessor: (r) => r.id.toString(),
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

